import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { AccountListContext } from '../../../context/AccountListContext';
import { COMPANY_LOGO_BASE_URL, MARKET_FORECAST_YEAR } from '../../../config/apiConfig';
import { formatValueInBillions, numberWithCommas, smartRevenueDisplay, truncateDescription } from '../../../services/commonService';
import SlicedCircle from '../../HtmlElements/SlicedCircle';
import * as FeatherIcon from 'react-feather';
import { Link, useParams } from 'react-router-dom';
import { useUser } from '../../../context/UserContext';
import RelevanceScore from '../../HtmlElements/RelevanceScore';
import AccountPlanTdComp from '../../Accounts/AccountPlanTdComp';
import { Button, Modal } from 'react-bootstrap';
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from 'react-redux';
import DownloadButtons from './DownloadButtons';
import { submitDeliveryExcellenceRequest } from '../../../store/features/actions/deliveryExcellenceActions';
import { submitRenewalRequest } from '../../../store/features/actions/renewalAgentActions';
import { submitGetLiveAccountsRequest } from '../../../store/features/actions/fetchLiveAccountsActions';
import { FetchSpotContactsRequest } from '../../../store/features/actions/targetedReachout/spotContactsActions';
import Select from 'react-select';
import { Download, MoreHorizontal } from 'react-feather';
import CircularLoader from '../../HtmlElements/CircularLoader';
import DeliveryExcellenceModal from '../AccountDetails/Agents/DeliveryExcellenceModal';
import RenewalNoteModal from '../AccountDetails/Agents/RenewalNoteModal';
import TR3DotMenu from '../genericComponents/genericTableComp/TR3DotMenu';
import iq_api_v2 from '../../../services/iqApiV2';
import { useBanner } from '../../../context/BannerContext';

export default function AllAccountsTableView({searchTerm = "", handleAccountPlanDownload}) {
  
    let options = [];
    const { user, my_favourites } = useUser();
    const { clientName } = useParams(); 

    const { allAccounts, favouriteAccounts, toggleFavourite, loading } = useContext(AccountListContext);

    const dispatch = useDispatch();
    const deliveryExcellenceReducerResponse = useSelector(state => state.deliveryExcellenceReducer);
    const renewalReducerResponse = useSelector(state => state.renewalReducer);
    const { loadingData, successData, errorData } = useSelector(state => state.getLiveAccountsReducer);
    const { spotContactsData, spotContactsLoading } = useSelector(state => state?.spotContactsReducer);

    const [expandedRows, setExpandedRows] = useState({});

    const [currentRecords, setCurrentRecords] = useState([]); // State for current page records
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(10);
    const [sortField, setSortField] = useState('account_name');
    const [sortOrder, setSortOrder] = useState('asc');
    const [sortedRecords, setSortedRecords] = useState([])
    const [totalPages, setTotalPages] = useState(0);

    const [all_accounts, setAllAccountsData] = useState(allAccounts || []);

    const [showModal, setShowModal] = useState(false);
    const [inputAccount, setInputAccount] = useState("");
    const [inputClient, setInputClient] = useState("");
    const [note, setNote] = useState("");
    const [noteType, setNoteType] = useState("");

    const [context, setContext] = useState("");
    const [errors, setErrors] = useState({});

    const [contact, setContact] = useState("");
    const [contactError, setContactError] = useState("");
    const [consumptionFileError, setConsumptionFileError] = useState("");
    const [company, setCompany] = useState("");
    const [liveCompanyEnabled, setLiveCompanyEnabled] = useState(true);
    const [contacts, setContacts] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([])

    const showBanner = useBanner();

    useEffect(() => {
      setCurrentPage(1)
    }, [searchTerm])

    useEffect(()=> {
        const favouriteCompetitors = favouriteAccounts || [];
        const favouriteNamesSet = new Set(favouriteCompetitors?.map(fav => fav.name));

        // Mark accounts as favourite
        const accountsWithFavourites = allAccounts?.map((account) => {

            // check if company is public or private: due to existing records, multiple records getting, so filter
            const account_type_info = account?.company_details?.filter(item => item?.company_type);
            account.company_type = account_type_info?.[0]?.company_type || ''
            // End: check if company is public or private: due to existing records, multiple records getting, so filter

            const updatedAccount = { ...account };  // Create a copy to avoid direct mutation
            updatedAccount.isFavourite = favouriteNamesSet.has(account.name) ? 1 : 0;
            return updatedAccount;
        });

        // Sort accounts by isFavourite
        const sortedAccounts = accountsWithFavourites.sort((a, b) => b.isFavourite - a.isFavourite);
        setAllAccountsData(sortedAccounts);

    }, [my_favourites, favouriteAccounts, allAccounts, loading]);

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
        setCurrentPage(1)
        setSortField(field);
        setSortOrder(order);
    };
    
    const getSortedRecords = () => {
        const sortedRecords = all_accounts.sort((a, b) => {
            let is_numeric = false;
            // let dataSortField = "financials.0.revenue";
            let dataSortField = "financials.0.financials.0.value";

            if (sortField === 'isFavourite') {
                dataSortField = "isFavourite";
                is_numeric = true;
            } else if (sortField === 'account_name') {
                dataSortField = "name";
            } else if (sortField === 'industry_name') {
                dataSortField = "company_details.0.trbc_industry_name";
            } else if (sortField === 'relevance_score') {
                dataSortField = "relevance_score";
                is_numeric = true;
            } else if (sortField === 'revenue') {
                dataSortField = "financials.0.financials.0.value";
                is_numeric = true;
            } else if (sortField === 'opportunity_count') {
                dataSortField = "opportunity_count";
                is_numeric = true;
            } else if (sortField === 'contact_count') {
                dataSortField = "contact_count";
                is_numeric = true;
            } 
            else if (sortField === 'company_type') {
                dataSortField = "company_type";
            }
    
            // Helper function to access nested properties by string path
            const getNestedValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

            const valueA = getNestedValue(a, dataSortField);
            const valueB = getNestedValue(b, dataSortField);

            // Handling NaN or undefined values
            const numA = is_numeric ? parseFloat(valueA) : valueA;
            const numB = is_numeric ? parseFloat(valueB) : valueB;

            // Handle NaN or undefined by pushing to the bottom
            if (valueA === undefined || valueA === null || valueA === '') return sortOrder === "asc" ? -1 : 1;
            if (valueB === undefined || valueB === null || valueB === '') return sortOrder === "asc" ? 1 : -1;

            // Normal comparison
            if (typeof valueA === 'string' && typeof valueB === 'string') {
            return sortOrder === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            } else {
            if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
            if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
            }
    
            return 0;
        });
    
        return sortedRecords;
    };

    useEffect(() => {
        if(all_accounts.length){
          const sortedRecords = getSortedRecords();
          setSortedRecords(sortedRecords);
        }else{
          setSortedRecords([]);
        }

    }, [all_accounts, sortField, sortOrder]);

    useEffect(() => {
        const filteredRecords = sortedRecords.filter(record =>
            record.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        const indexOfLastRecord = currentPage * perPage;
        const indexOfFirstRecord = indexOfLastRecord - perPage;
        // const current_records = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
        const current_records = filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord);

        setCurrentRecords(current_records); // Set current page records
        setTotalPages(Math.ceil(filteredRecords.length / perPage));

        setFilteredRecords(filteredRecords)

    }, [currentPage, sortedRecords, sortField, sortOrder, searchTerm]);

    const handleFirstPage = () => {
        setCurrentPage(1);
    };

    const handleLastPage = () => {
        setCurrentPage(totalPages);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    
    const getPageNumbers = () => {
        const pageNumbers = [];
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, currentPage + 2);
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const toggleRow = (index) => {
        setExpandedRows((prevState) => ({
          ...prevState,
          [index]: !prevState[index],
        }));
    };

    // +++++++++++++++++++++++++++++++++++++++++++++++++++++
    useEffect(() => {
      // if(spotContactsData?.length){
        // console.log("CONTACTS DATA: "+JSON.stringify(spotContactsData));
        const contatc_result = spotContactsData.map(({ _id, name }) => ({ _id, name }));
        // console.log("CONTACTS: "+JSON.stringify(contatc_result));
        setContacts(contatc_result);
      // }
    }, [spotContactsData]);

    const handleDownloadNotes = (note_type = "", client_name = "", account_name = "") => {
        const notes = {
            "delivery_excellence" : "Delivery Excellence",
            "renewal_note" : "Renewal Note",
            "ppm" : "PPM"
        }

        if(note_type === 'renewal_note'){
            dispatch(submitGetLiveAccountsRequest({account_name: account_name}));
            dispatch(FetchSpotContactsRequest({ clientName: client_name, accountName: account_name, userId: user?.id, type: 'all' }));
        }

        if(note_type !== "ppm"){
            setNote(note_type);
            setNoteType(notes[note_type]);
            setInputClient(client_name);
            setInputAccount(account_name);
            setShowModal(true);
        }
    }
    
    const handleModalClose = () => {
        setInputClient("");
        setInputAccount("");

        if(note === "delivery_excellence"){
          setContext("");
          setErrors({context: ""});
        }else if(note === "renewal_note"){
            setContact("");
            setContactError("");
            setCompany("");
            setConsumptionFileError("");
          }

        setNote("");
        setNoteType("");
        setShowModal(false);        
    }
 
    const handleSubmit = (e) => {
        e.preventDefault();
        
        let formData = {};        
        if(note === "delivery_excellence"){
            const validationErrors = {};
            if(note === "delivery_excellence")
                if (!context) validationErrors.context = "Context is required.";
        
            if (Object.keys(validationErrors).length > 0) {
              setErrors(validationErrors);
              return;
            }

            formData = {
              clientName: inputClient,
              accountName: inputAccount,
              context: context,
              response_type: "pdf"
            };
            dispatch(submitDeliveryExcellenceRequest({ formData }));
            setContext("");
            setErrors({context: ""});
            setContact("");
            setContactError("");
            setCompany("");
            setConsumptionFileError("");
        }else if(note === "renewal_note"){
            let isValid = true;

            if (!contact) {
              setContactError("Contact is required.");
              isValid = false;
            } else {
              setContactError("");
            }
        
            if (!company) {
              setConsumptionFileError("Live Company is required.");
              isValid = false;
            } else {
              setConsumptionFileError("");
            }
        
            if (isValid == false) return;
        
            formData = {
              clientName: inputClient,
              accountName: inputAccount,
              contact: contact,
              account_id: company,
              response_type: "pdf"
            };
        
            dispatch(submitRenewalRequest(formData));
            setContext("");
            setErrors({context: ""});
            setContact("");
            setContactError("");
            setCompany("");
            setConsumptionFileError("");
        }else{
            formData = {};
        }
    
        setErrors({});
      };

      useEffect(() => {
        if(successData.length){
          setCompanyOptions(successData);
        }else{
          setCompanyOptions([]);
        }

      }, [successData]);
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++
    
    const generateGo = async(client_name, account_name) => {
      try {
        const data = {
          client: client_name,
          account: account_name,
        }
        const response = await iq_api_v2.post(
          "opportunities/generate_new_growth_area",
          {},
          { params: data }
        );

        if(response?.data?.task_id){
          showBanner({
            message: "Request has been sent!",
            title: "Alert",
            type: "success",
            duration: 10000,
          });
        }else{
          showBanner({
            message: "Something went wront. Please try later.",
            title: "Alert",
            type: "error",
            duration: 10000,
          });
        }
        
      } catch (err) {
          console.log("Something went wront. Please try later.", err)
          showBanner({
            message: "Something went wront. Please try later.",
            title: "Alert",
            type: "error",
            duration: 10000,
          });
      }
    }

    return (
      <div className="row">
        <div className="accounts_table_block ">
          <div className="table-responsive">
            <table className="accounts_table ">
              <thead className="accounts_thead">
                <tr className="tr_growth">
                  {/* <th className="accounts_th text-center cursorP" width="50" onClick={() => handleSort('isFavourite')}> 
                            <i className='fa fa-bookmark-o' aria-hidden="true"></i> {' '}
                            {sortField === 'isFavourite' && (sortOrder === 'asc' ? '▲' : '▼')}    
                        </th> */}
                  <th
                    className="accounts_th cursorP"
                    width="350"
                    onClick={() => handleSort("account_name")}
                  >
                    {/* <FeatherIcon.Box className='icons_table ' /> {' '} */}
                    Account Name{" "}
                    {sortField === "account_name" &&
                      (sortOrder === "asc" ? "▲" : "▼")}
                  </th>
                  <th
                    className="accounts_th cursorP" width="270"
                    onClick={() => handleSort("industry_name")}
                  >
                    Industry{" "}
                    {sortField === "industry_name" &&
                      (sortOrder === "asc" ? "▲" : "▼")}
                  </th>

                  {/* <th
                    className="accounts_th cursorP" width="150"
                    onClick={() => handleSort("company_type")}
                  >
                    Company Type {" "}
                    {sortField === "company_type" &&
                      (sortOrder === "asc" ? "▲" : "▼")}
                  </th> */}

                  {/* <th
                    className="accounts_th cursorP text_left"
                    width="100"
                    onClick={() => handleSort("relevance_score")}
                  >
                    Match{" "}
                    {sortField === "relevance_score" &&
                      (sortOrder === "asc" ? "▲" : "▼")}
                  </th> */}
                  <th
                    className="accounts_th cursorP text_left px-4"
                    width="125"
                    onClick={() => handleSort("revenue")}
                  >
                    {/* <FeatherIcon.DollarSign className='icons_table ' />  {' '} */}
                    Account Revenue{" "}
                    {sortField === "revenue" &&
                      (sortOrder === "asc" ? "▲" : "▼")}
                  </th>

                  <th className="accounts_th cursorP text_left px-4" width="120"
                    onClick={() => handleSort("opportunity_count")}
                  >
                    Opportunities {' '}

                    {sortField === "opportunity_count" &&
                      (sortOrder === "asc" ? "▲" : "▼")}

                  </th>

                  <th className="accounts_th cursorP text_left px-4" width="120"
                    onClick={() => handleSort("contact_count")}
                  >
                    Contacts

                    {sortField === "contact_count" &&
                      (sortOrder === "asc" ? "▲" : "▼")}

                  </th>

                  {user?.company_name == 'MARKETS & MARKETS' && (<th
                    className="accounts_th cursorP text_left"
                    width="450"
                    onClick={() => handleSort("account_plan")}
                  >
                    {/* <FeatherIcon.DollarSign className='icons_table ' />  {' '} */}
                    Documents{" "}
                    {sortField === "account_plan" &&
                      (sortOrder === "asc" ? "▲" : "▼")}
                  </th>)}

                  <th className="accounts_th cursorP text_right" style={{
                    width: '30px'
                  }}></th>
                </tr>
              </thead>
              <tbody className="accounts_tbody">
                {currentRecords.map((account, index) => {
                  let accountStatus = account.status;
                  account.relevance_score = account?.relevance_score
                    ? account.relevance_score
                    : Math.floor(Math.random() * (90 - 61) + 61);
                  let account_displayname = account?.company_details?.[0]
                    ?.display_name
                    ? account?.company_details?.[0]?.display_name
                    : account.name;

                  return (
                    <tr key={index} className={`${accountStatus === 1 ? '' : 'geting_ready_tr'}`}>
                      {accountStatus === 1 ? (
                        <>
                          {/* <td className="accounts_td text-center">
                                    <div className="all_account_icon_block bookmar_icon" onClick={() => toggleFavourite(account._id)}>
                                        <i className={`fa ${account.isFavourite ? 'fa-bookmark' : 'fa-bookmark-o'}`} aria-hidden="true"></i>
                                    </div>
                                </td> */}
                          <td className="accounts_td">
                             {account?.company_type && (
                                <div className="pull-right mt-2">
                                  <span className="badge badge-dark">
                                    {account.company_type.toLowerCase().includes("private")
                                      ? "Private"
                                      : account.company_type.toLowerCase().includes("public")
                                      ? "Public"
                                      : account.company_type}
                                  </span>
                                </div>
                              )}

                            <div className="use_case_text d-flex align-items-center">
                              <Link
                                className="link"
                                to={`/account_details/${account._id}/${encodeURIComponent(account.name)}/${encodeURIComponent(account?.client)}`}
                              >
                                <img
                                  key={`account_img_${account?.name}`}
                                  width=""
                                  src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                                    account?.name
                                  )}`}
                                  alt="image"
                                  className="all_account_icon_img"
                                />
                              </Link>
                              
                              <Link
                                className="link"
                                to={`/account_details/${account._id}/${encodeURIComponent(account.name)}/${encodeURIComponent(account?.client)}`}
                              >
                                <p className="account_name mb-0">
                                  {account_displayname} {' '}
                                </p>
                              </Link>
                            </div>
                          </td>
                          <td className="accounts_td">
                            {account?.company_details?.[0]?.trbc_industry_name}
                          </td>

                          {/* <td className="accounts_td">
                            {account?.company_type}
                          </td> */}

                          {/* <td className="accounts_td rev_score_block text-left">
                            {account.relevance_score && (
                              <div className="d-flex">
                                {account.relevance_score} %
                              </div>
                            )}
                          </td> */}
                          <td className="accounts_td text_left px-4">

                            {account?.company_type && account?.company_type.toLowerCase().includes('private') ? 'Not Available' : '' }

                            {account?.company_type && account?.company_type.toLowerCase().includes('private') == false && account?.financials?.[0]?.financials?.[0]
                              ?.value && (
                              <span className="percentage_cagr">
                                <span style={{color: "#1AAA07"}}>$</span>{" "}
                                {formatValueInBillions(
                                  account?.financials?.[0]?.financials?.[0]
                                    ?.value
                                )}{" "}
                                Bn{" "}
                              </span>
                            )}
                          </td>

                          <td className="accounts_td text_left px-4">
                            {account?.opportunity_count && (
                              <span className="percentage_cagr">
                                <FeatherIcon.Zap style={{color: "#E67B1E", width: "12px"}} className='icons_table ' />{" "}
                                {account?.opportunity_count ? account?.opportunity_count : ''}{" "}
                              </span>
                            )}
                          </td>

                          <td className="accounts_td text_left px-4">
                            {account?.contact_count && (
                              <span className="percentage_cagr">
                                <FeatherIcon.User style={{color: "#1E74E6", width: "14px"}} className='icons_table ' />{" "}
                                {account?.contact_count}{" "}
                              </span>
                            )}
                          </td>

                          {user?.company_name == 'MARKETS & MARKETS' && (<td className="download_account_planbtns pt-2" style={{position: "relative"}}>
                            {/* <DownloadButtons
                                account={account}
                                handleAccountPlanDownload={handleAccountPlanDownload}
                                handleDownloadNotes={handleDownloadNotes}
                            /> */}

                            {/* <button
                              className="doawnload_btn ml-2"
                              onClick={() =>
                                handleAccountPlanDownload(account?.company_code, account?.client_code)
                              }
                            >
                              <Download className="download_arrow" />
                              <span className="download_span">Account Plan</span>
                            </button> */}

                            <button
                              className="doawnload_btn ml-2"
                              onClick={() =>
                                handleDownloadNotes("delivery_excellence", account?.client_name, account?.name)
                              }
                            >
                              <Download className="download_arrow" />
                              <span className="download_span">Delivery Excellence Note</span>
                            </button>

                            <button
                              className="doawnload_btn ml-2"
                              onClick={() =>
                                handleDownloadNotes("renewal_note", account?.client_name, account?.name)
                              }
                            >
                              <Download className="download_arrow" />
                              <span className="download_span">Renewal Note</span>
                            </button>

                            {/* <div className="dropdown-divider" /> */}

                            {/* <button
                              className="doawnload_btn ml-2"
                              onClick={() =>
                                handleDownloadNotes("ppm", account?.client_name, account?.name)
                              }
                            >
                              <Download className="download_arrow" />
                              <span className="download_span">PPM</span>
                            </button> */}

                          </td>)}

                          <td >

                              {/* // Commented as suggested by Agney
                               {user?.role_key === 'CLIENT' &&
                                <Button type='button' variant='generate' className='btn btn-primary font12 px-1' style={{width: '100px',border:'none'}}
                                  onClick={() => generateGo(account?.client_name, account?.name)}
                                >Generate G.O.</Button>
                              } */}

                            <Link
                              className="link text_right "
                              to={`/account_details/${account._id}/${encodeURIComponent(account.name)}/${encodeURIComponent(account?.client)}`}
                            >
                              {/* <BookmarkArrow
                                bookmarkClick={null}
                                arrowClick={null}
                              /> */}
                              <TR3DotMenu  menuItems={[]}/>
                            </Link>
                          </td>
                        </>
                      ) : (
                        <>
                          {/* <td className="accounts_td text-center">
                                            <div className="all_account_icon_block bookmar_icon" onClick={() => toggleFavourite(account._id)}>
                                                <i className={`fa ${account.isFavourite ? 'fa-bookmark' : 'fa-bookmark-o'}`} aria-hidden="true"></i>
                                            </div>
                                        </td> */}
                          <td className="accounts_td " >
                            <div className="use_case_text d-flex align-items-center">
                              <Link className="link">
                                <img
                                  width=""
                                  src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                                    account?.name
                                  )}`}
                                  alt="image"
                                  className="all_account_icon_img"
                                />
                              </Link>
                              <Link className="link">
                                <span className="account_name">
                                  {account.name}{" "}
                                </span>
                              </Link>

                           
                              {/* <div className="circle_ready">
                                <div id="outer-circle">
                                  <div id="inner-circle"></div>
                                </div>
                                <p className="getting_ready">
                                  account setup is in progress.
                                </p>
                              </div> */}
                            </div>
                          </td>
                          <td colSpan={8}>
                          <div className="circle_ready new_blue_circle_ready">
                                <div id="new_blue_outer-circle">
                                  <div id="new_blue_inner-circle"></div>
                                </div>
                                <p className="new_blue_getting_ready">
                                  Account setup is in progress.
                                </p>
                              </div>
                          </td>
                          {/* <td colSpan={7}>
                            <div className="circle_ready new_blue_circle_ready">
                                <div id="new_blue_outer-circle">
                                  <div id="new_blue_inner-circle"></div>
                                </div>
                                <p className="new_blue_getting_ready">
                                  Account setup is in progress.
                                </p>
                            </div>
                          </td> */}
                          {/* <td className="accounts_td"> */}
                            {/* {account?.company_details?.[0]?.trbc_industry_name} */}
                          {/* </td> */}
                          {/* <td className="accounts_td rev_score_block text-center"> */}
                            {/* {account.relevance_score &&
                                            <>
                                                <span className="releavance_score green_back">{account.relevance_score ? <RelevanceScore relevanceScore={account.relevance_score} /> : 81}%</span>
                                                <a href="#" className="relevance_img">
                                                    <SlicedCircle percentage={account.relevance_score ? account.relevance_score : 81} />
                                                </a>
                                            </>
                                            } */}
                          {/* </td> */}
                          {/* <td className="accounts_td text_right px-4"> */}
                            {/* {account?.financials?.[0]?.revenue &&
                                                <span className='percentage_cagr'>$ {formatValueInBillions(account?.financials?.[0]?.revenue)} Bn </span>
                                            } */}
                          {/* </td> */}
                          {/* <td></td> */}
                          {/* <td></td> */}
                          {/* <td></td> */}
                          {/* <td></td> */}
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            <nav className="table_pagination_custom">
              {all_accounts.length > perPage && (
                <ul className="showing-per-page-info">
                  <li className="page-item">
                    <span className="showing">Showing </span>{" "}
                    {all_accounts.length > 0
                      ? (currentPage - 1) * perPage + 1
                      : 0}
                    -{Math.min(currentPage * perPage, filteredRecords.length)} of{" "}
                    {numberWithCommas(filteredRecords.length)}
                  </li>
                </ul>
              )}

              {all_accounts.length > perPage && (
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button onClick={handleFirstPage} className="page-link">
                      First
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button onClick={handlePrevPage} className="page-link">
                      <i className="fa fa-angle-left" aria-hidden="true"></i>
                    </button>
                  </li>
                  {getPageNumbers().map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        pageNumber === currentPage ? "active" : ""
                      }`}
                    >
                      <button
                        onClick={() => handlePageChange(pageNumber)}
                        className="page-link"
                      >
                        {pageNumber}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button onClick={handleNextPage} className="page-link">
                      <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button onClick={handleLastPage} className="page-link">
                      Last
                    </button>
                  </li>
                </ul>
              )}
            </nav>
          </div>
        </div>

        {/* {allAccounts.map((account, index) => (
                <div className="col-md-4" key={index}>

                    <div className="all_account_tile"> Table
                        <div className="all_account_icon_block" onClick={() => toggleFavourite(account._id)}>
                            <i className={`fa ${account.isFavourite ? 'fa-bookmark' : 'fa-bookmark-o'}`} aria-hidden="true"></i>
                        </div>
                        <div className="clearfix"></div>
                        <div className="all_account_block">
                            
                            <div className="all_account_subblock">
                                <img src={`${COMPANY_LOGO_BASE_URL}${account?.name}`} alt="image" className="all_account_icon_img" />
                            </div>

                            <h5 className="all_account_head">{account.name}</h5>

                            <p className="all_account_info_para">
                                {truncateDescription(account.overview?.[0]?.text, 70).truncated_info}
                            </p>

                            <div className="dflex pie_info">
                                <a href="#" className="pie_info_per"><span>81%</span></a>
                                <a href="#" className="pie_chart">
                                    <span><img src="/img/icons/pie_chart_icon.png" alt="image" className="chart_pie_icon" width="16px" /></span>
                                </a>
                                <a href="#" className="pie_number">
                                    <span><img src="/img/icons/pie_icon.png" alt="image" className="pie_icon" />$ {account?.revenue}</span>
                                </a>
                                <a href="#" className="pie_trend">
                                    <span><i className="fa fabuilding" ariahidden="true"></i> {account?.business_units?.[0]?.industry}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            ))} */}

        {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
        <DeliveryExcellenceModal
          show={note === "delivery_excellence" && showModal}
          onClose={handleModalClose}
          clientName={inputClient}
          accountName={inputAccount}
        />

        <RenewalNoteModal
          show={note === "renewal_note" && showModal}
          onClose={handleModalClose}
          clientName={inputClient}
          accountName={inputAccount}
          contacts={contacts}
          companies={companyOptions}
          spotContactsLoading={spotContactsLoading}
        />
        {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      </div>
    );
}
